import { render, staticRenderFns } from "./LaudosVisaoGeral.vue?vue&type=template&id=0d022c8c&"
import script from "./LaudosVisaoGeral.vue?vue&type=script&lang=js&"
export * from "./LaudosVisaoGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports